import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as dashboardActions from '../../../pillar/dashboard/store/actions';
import * as securityActions from '../actions';
import { ModuleConfiguration } from '../../security.module.config';
import { RoleListModel } from '../../models/RoleListModel';
import { RoleModel } from '../../models/RoleModel';
import { LookupModel } from '../../../common/models/LookupModel';
import * as actions from '../../../pillar/dashboard/store/actions/';

let stateReducer;
export function stateReducerWrapper (state = new TileState<RoleListModel, RoleModel>(), action: actions.Actions<any>): TileState<any, any>  {
  if(!stateReducer){
    stateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, RoleListModel, RoleModel, new TileState<RoleListModel, RoleModel>());
  }
  return stateReducer(state, action);
}

function roleSort(a: RoleModel, b: RoleModel): number {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
}

function permissionSort(a: LookupModel, b: LookupModel): number {
  if (a.description < b.description) {
    return -1;
  }
  if (a.description > b.description) {
    return 1;
  }
  return 0;
}

export function rolesReducer(state = new TileState<RoleListModel, RoleModel>(), action: dashboardActions.Actions<RoleModel>): TileState<RoleListModel, RoleModel> {
  switch (action.type) {
    case securityActions.ADD_ROLE_TO_ROLE_SUCCESS:
      var addAction = action as securityActions.AddRoleToRoleSuccessAction;
      if (state.selected.key === addAction.payload.roleKey) {
        var addedRole = addAction.payload.role;
        return {
          ...state,
          selected: {
            ...state.selected,
            includedRoles: state.selected.includedRoles.concat([addedRole]).sort(roleSort)
          }
        }
      }
    case securityActions.REMOVE_ROLE_FROM_ROLE_SUCCESS:
      var removeAction = action as securityActions.RemoveRoleFromRoleSuccessAction;
      if (state.selected.key === removeAction.payload.roleKey) {
        var removedRole = removeAction.payload.role;
        return {
          ...state,
          selected: {
            ...state.selected,
            includedRoles: state.selected.includedRoles.filter(r => r.key !== removedRole.key).sort(roleSort)
          }
        }
      }
    case securityActions.ADD_PERMISSION_TO_ROLE_SUCCESS:
      var addPermissionAction = action as securityActions.AddPermissionToRoleSuccessAction;
      if (state.selected.key === addPermissionAction.payload.roleKey) {
        var addedPermission = addPermissionAction.payload.permission;
        return {
          ...state,
          selected: {
            ...state.selected,
            includedPermissions: state.selected.includedPermissions.concat([addedPermission]).sort(permissionSort)
          }
        }
      }
    case securityActions.REMOVE_PERMISSION_TO_ROLE_SUCCESS:
      var removePermissionAction = action as securityActions.RemovePermissionToRoleSuccessAction;
      if (state.selected.key === removePermissionAction.payload.roleKey) {
        var removedPermission = removePermissionAction.payload.permission;
        return {
          ...state,
          selected: {
            ...state.selected,
            includedPermissions: state.selected.includedPermissions.filter(r => r.key !== removedPermission.key).sort(permissionSort)
          }
        }
      }
    default:
      return stateReducerWrapper(state, action);
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/reducers/roles.reducer.ts